import React, { FC } from 'react'
import { StyledLogo } from './Logo.styles'
import src from '@src/assets/img/logo.png'

export const Logo: FC = () => <StyledLogo src={src} />
